export const PALETTE = ["#C2410C", "#0F766E", "#B45309", "#4D7C0F", "#9F1239", "#1D4ED8", "#7C2D12", "#065F46", "#A16207", "#57534E", "#6D28D9", "#0E7490"];

export const pathColor = (name = "") => {
  let h = 0;
  for (const ch of name) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return PALETTE[h % PALETTE.length];
};
